var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-view"},[_c('controls-panel'),_c('storage-tabs'),_c('companies-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }